import { render, staticRenderFns } from "./DevFoldingCard.vue?vue&type=template&id=2a7c62e4&scoped=true&"
import script from "./DevFoldingCard.vue?vue&type=script&lang=js&"
export * from "./DevFoldingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7c62e4",
  null
  
)

export default component.exports